'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/fares-optimizer-date-chart-tooltip.html'));
var FaresOptimizerDateChart = function FaresOptimizerDateChart(AbstractChart, chartGroups, chartRangeBars, chartVerticalLine, chartRectangle) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  function ladderDetailsTooltip(data) {
    return tooltipTemplate(data.tooltipData);
  }
  var Chart = function Chart(container) {
    AbstractChart.call(this, container);

    // chart components
    var groups = chartGroups('group');
    var horizontalBars = chartRangeBars('begin', 'end');
    var isShowMultipleLines = true;
    var verticalLineInboundEndDate = chartVerticalLine('inboundTravelEndDate').withStrokeWidth(5).withOpacity(1).withMultipleLine(isShowMultipleLines).params(this.params).scales(this.scales);
    var verticalLineEndDate = chartVerticalLine('travelEndDate').withStrokeWidth(3).withOpacity(1).withMultipleLine(isShowMultipleLines).params(this.params).scales(this.scales);
    var ticketingDatesRectangle = chartRectangle('firstTicketDate', 'lastTicketDate').withCustomHeight(4).params(this.params).scales(this.scales);
    var effectiveDatesRectangle = chartRectangle('effectiveDate', 'discontinueDate').params(this.params).scales(this.scales);
    var tooltipTriggerRectangle = chartRectangle('start', 'end', ladderDetailsTooltip).params(this.params).scales(this.scales);
    this.render = function (data) {
      this.setDataPropertyName('applicableDates');
      var dateRange = data.dateRange;
      verticalLineInboundEndDate.withData(data.inboundTravelEndData);
      verticalLineEndDate.withData(data.travelEndData);
      tooltipTriggerRectangle.withData([{
        start: dateRange.startDay,
        end: dateRange.endDay,
        className: 'tooltip-trigger',
        tooltipData: data.tooltipData
      }]);
      ticketingDatesRectangle.withData(data.ticketingDateRange);
      effectiveDatesRectangle.withData(data.effectiveDateRange);
      this.initChart(data, undefined, chartParams());
      this.scales = chartScales(this.params, [dateRange.startDay, dateRange.endDay]);
      this.callForDataGroup([effectiveDatesRectangle, ticketingDatesRectangle, groups, horizontalBars, verticalLineInboundEndDate, verticalLineEndDate, tooltipTriggerRectangle], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
FaresOptimizerDateChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsHorizontalRangeBars', 'ChartElementsVerticalLine', 'ChartElementsSingleRectangle'];
module.exports = FaresOptimizerDateChart;